import * as React from 'react';

import Empty from 'antd/es/empty';

const EmptyLoader: React.FC = () => {
	return <Empty
		image={Empty.PRESENTED_IMAGE_SIMPLE}
		description="Loading..."
		style={{ marginBlock: 8 }}
		imageStyle={{ height: 35 }}
	/>;
};

export default EmptyLoader;
